import {
  CandidateContactInformationConst,
  CandidatesConst,
} from '@axiom/const';
import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

const EMPLOYMENT_STATUSES = Object.values(CandidatesConst.EmploymentStatuses);

const PREFERRED_CONTACT_METHODS = Object.keys(
  CandidateContactInformationConst.PreferredContactMethod
) as Array<
  keyof typeof CandidateContactInformationConst.PreferredContactMethod
>;

export const CandidateContactInformationSchema = z.object({
  employmentStatus: z.enum(ZodArrayToEnum(EMPLOYMENT_STATUSES)),
  personalEmail: z.string().nullable(),
  workEmail: z.string().nullable(),
  preferredContactMethod: z.enum(ZodArrayToEnum(PREFERRED_CONTACT_METHODS)),
  homePhone: z.string().nullable(),
  mobilePhone: z.string().nullable(),
});

export type CandidateContactInformation = z.infer<
  typeof CandidateContactInformationSchema
>;
